import { render } from "./MathEquation.vue?vue&type=template&id=05c79787&scoped=true"
import script from "./MathEquation.vue?vue&type=script&lang=js"
export * from "./MathEquation.vue?vue&type=script&lang=js"

import "./MathEquation.vue?vue&type=style&index=0&id=05c79787&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05c79787"]])

export default __exports__